import React from 'react'
import UrlInput from './UrlInput'
import { QRNormal, QRResImage, QRRandRect, QRFunc, QRDsj, QRBubble, QRLine, QRImage} from 'react-qrbtf'
import { exportComponentAsJPEG, exportComponentAsPDF, exportComponentAsPNG } from 'react-component-export-image';


class ComponentToPrint extends React.Component {
 render() {

   	      let isVisiableQR = this.props.isVisiableQR;
		  let idQR = this.props.idQR;
		  let valueQR = this.props.valueQR;
		  let sizeQR = this.props.sizeQR;
		  let opacityQR = this.props.opacityQR;
		  let levelQR = this.props.levelQR;
		  let typeQR = this.props.typeQR;
		  let posTypeQR = this.props.posTypeQR;
		  let posTypeQR2 = this.props.posTypeQR2;
		  let otherColorQR = this.props.otherColorQR;
		  let posColorQR = this.props.posColorQR;		  
		  let circleColorQR = this.props.circleColorQR;
		  let funcTypeQR = this.props.funcTypeQR;
		  let directionQR = this.props.directionQR;
		  let scaleQR = this.props.scaleQR;
		  let crossWidthQR = this.props.crossWidthQR;
		  let posWidhQR = this.props.posWidhQR;
		  let lineWidthQR = this.props.lineWidthQR;
		  let icon = this.props.icon;		  
		  const isMarginQR= this.props.isMarginQR;
		  //design style
		  let QRstyle = this.props.QRstyle;		  
		  
		  
		  if (isVisiableQR === false) 
			  { return (
			    <div className="qrstyle">...</div>
			  )
			  }
		else
			if (QRstyle === "QRNormal")
			{
				return (
					<div className="qrstyle">					  
					  <QRNormal
						className="imgqrstyle"				
                        id={idQR}						
						value={valueQR}
						size={sizeQR}
						level={levelQR}
						type={typeQR}
						posType={posTypeQR}
						opacity={opacityQR}
						otherColor={otherColorQR}
						posColor={posColorQR}
						icon={icon}						
					  />
					  
					  
					</div>
				)
			}
		else
			if (QRstyle === "QRResImage")
			{
				return (
					<div className="qrstyle">
					  <QRResImage					    
						className="imgqrstyle"
						
						id={idQR}				
						value={valueQR}
						size={sizeQR}
						level={levelQR}
						type={typeQR}
						posType={posTypeQR}
						opacity={opacityQR}
						otherColor={otherColorQR}
						posColor={posColorQR}						
						image={icon}
						
					  />
					</div>
				)
			}
		else
			if (QRstyle === "QRImage")
			{
				return (
					<div className="qrstyle">
					  <QRImage					    
						className="imgqrstyle"
						
						id={idQR}				
						value={valueQR}
						size={sizeQR}
						level={levelQR}
						type={typeQR}
						posType={posTypeQR}
						opacity={opacityQR}
						otherColor={otherColorQR}
						posColor={posColorQR}						
						image={icon}
						
					  />
					</div>
				)
			}			
		else
			if (QRstyle === "QRRandRect")
			{
				return (
					<div className="qrstyle">
					  <QRRandRect					    
						className="imgqrstyle"						
						id={idQR}				
						value={valueQR}
						level={levelQR}
					  />
					</div>
				)
			}			
		else
			if (QRstyle === "QRBubble")
			{
				return (
					<div className="qrstyle">
					  <QRBubble					    
						className="imgqrstyle"						
						id={idQR}				
						value={valueQR}
						level={levelQR}
						circleColor={circleColorQR}
						posColor={posColorQR}												
					  />
					</div>
				)
			}						
		else
			if (QRstyle === "QRFunc")
			{
				return (
					<div className="qrstyle">
					  <QRFunc
						className="imgqrstyle"
						id={idQR}				
						value={valueQR}
						size={sizeQR}
						level={levelQR}
						includeMargin={isMarginQR}
					  />
					</div>
				)
			}
		else
			if (QRstyle === "QRDsj")
			{
				return (
					<div className="qrstyle">
					  <QRDsj
						className="imgqrstyle"				
                        id={idQR}						
						value={valueQR}						
						level={levelQR}
						scale={scaleQR}
						crossWidth={crossWidthQR}
						posWidh = {posWidhQR}
						posType={posTypeQR2}

					  />
					</div>
				)
			}
		else
			if (QRstyle === "QR25D")
			{
				return (
					<div className="qrstyle">
					  <QRFunc
						className="imgqrstyle"
						id={idQR}				
						value={valueQR}
						size={sizeQR}
						level={levelQR}						
					  />
					</div>
				)
			}			
		else
			if (QRstyle === "QRLine")
			{
				return (
					<div className="qrstyle">
					  <QRLine
						className="imgqrstyle"
						id={idQR}				
						value={valueQR}
						size={sizeQR}
						level={levelQR}
						funcType={funcTypeQR}
						direction={directionQR}
						lineOpacity={opacityQR}
						lineColor={otherColorQR}
						posColor={posColorQR}						
						lineWidth={lineWidthQR}
					  />
					</div>
				)
			}

   
   

 }
}

class QRdiv extends React.Component {
	
constructor(props) {
   super(props);
   this.componentRef = React.createRef();
 }	



render() {
	
   	      let isVisiableQR = this.props.isVisiableQR;
		  let idQR = this.props.idQR;
		  let valueQR = this.props.valueQR;
		  let sizeQR = this.props.sizeQR;
		  let opacityQR = this.props.opacityQR;
		  let levelQR = this.props.levelQR;
		  let typeQR = this.props.typeQR;
		  let posTypeQR = this.props.posTypeQR;
		  let posTypeQR2 = this.props.posTypeQR2;
		  let otherColorQR = this.props.otherColorQR;
		  let posColorQR = this.props.posColorQR;
		  let circleColorQR = this.props.circleColorQR;
		  let scaleQR = this.props.scaleQR;
		  let crossWidthQR = this.props.crossWidthQR;
		  let posWidhQR = this.props.posWidhQR;
		  let lineWidthQR = this.props.lineWidthQR;
		  let funcTypeQR = this.props.funcTypeQR;
		  let directionQR = this.props.directionQR;
		  let formId = this.props.formId;
		  let icon = this.props.icon;
		  //console.log('base64 ' + icon );		  
		  let imgQR = this.props.imgQR;
		  const isMarginQR= this.props.isMarginQR;
		  //design style
		  let QRstyle = this.props.QRstyle;
	      if (isVisiableQR){
			return(
					  
					  <React.Fragment>
					  <UrlInput 
					     isVisiableQR = {isVisiableQR}	
						 valueQR={valueQR}
						 formId={formId}				 
					  />
					  
					   <div className="div-btn ">					   					   
					   <h3>Скачать</h3>
					   <button className="dl-btn" onClick={() => exportComponentAsJPEG(this.componentRef, 'sbQR_code.jpeg', 'white')}>
					   JPEG
					   </button>					  
					   <button className="dl-btn" onClick={() => exportComponentAsPNG(this.componentRef,'QR_code.png', 'white')}>
						 PNG
					   </button>					   
					   <button className="dl-btn" onClick={() => exportComponentAsPDF(this.componentRef,'sbQR_code.pdf', 'white')}>
						 PDF
					   </button>
					   </div>
					  
					  
					  
					   <ComponentToPrint ref={this.componentRef} 
						  idQR = {idQR}
						  formId = {formId}
						  valueQR = {valueQR}
						  sizeQR = {sizeQR}
						  levelQR = {levelQR}			  
						  typeQR = {typeQR}
						  posTypeQR = {posTypeQR}
						  posTypeQR2 = {posTypeQR2}
						  opacityQR = {opacityQR}
						  otherColorQR = {otherColorQR}
						  posColorQR = {posColorQR}
						  circleColorQR = {circleColorQR}
						  funcTypeQR = {funcTypeQR}
						  directionQR = {directionQR}
						  isMarginQR = {isMarginQR}
						  scaleQR = {scaleQR}
						  crossWidthQR = {crossWidthQR}
						  posWidhQR = {posWidhQR}
						  lineWidthQR = {lineWidthQR}
						  isVisiableQR = {isVisiableQR}	  			  
						  QRstyle = {QRstyle}
						  icon = {icon}
						  imgQR = {imgQR}					   

					   />
					   
					  </React.Fragment>

			)
		  }
		  else return null;
			
}

}
export default QRdiv
